module.exports = __webpack_public_path__ + "media/images/promo/smart_phone-a556e4c1ef7ff8e29f4358736550db5943d9aa18b6c8796b45118e494f634435.png";